/**
 * Cart Drawer Countdown Timer
 */
(function() {
  'use strict';
  
  var countdownTimer = null;
  
  function updateCountdown() {
    var timerEl = document.getElementById('cart-countdown-timer');
    if (!timerEl) return;
    
    var now = new Date();
    var cutoffHour = 18; // 6 PM - ajusta según necesites
    var cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);
    
    // Si ya pasó la hora de corte hoy, usar mañana
    if (now >= cutoff) {
      cutoff.setDate(cutoff.getDate() + 1);
    }
    
    var diff = cutoff - now;
    
    if (diff <= 0) {
      timerEl.textContent = '0h 0m 0s';
      return;
    }
    
    var hours = Math.floor(diff / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);
    
    timerEl.textContent = hours + 'h ' + minutes + 'm ' + seconds + 's';
  }
  
  function startCountdown() {
    if (countdownTimer) {
      clearInterval(countdownTimer);
    }
    
    updateCountdown();
    countdownTimer = setInterval(updateCountdown, 1000);
  }
  
  // Iniciar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCountdown);
  } else {
    startCountdown();
  }
  
  // Re-iniciar cuando el cart drawer se abre
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-cart-drawer-toggle]');
    if (toggle) {
      setTimeout(startCountdown, 300);
    }
  });
  
  // Observar cambios en el cart drawer
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        var timerEl = document.getElementById('cart-countdown-timer');
        if (timerEl && timerEl.textContent === '--:--:--') {
          startCountdown();
        }
      }
    });
  });
  
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  if (cartDrawer) {
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }
})();